import { Store } from 'vuex';
import { container } from '../container';
import { DEPENDENCIES } from '../container/dependencies.const';
import { CurrencyOptions } from '../i18n';
import { GETTERS_KEYS, RootStoreState } from '../store';
import { CurrencyFormatter } from './currency/currency-formatter';

const DefaultFormatter = new CurrencyFormatter();

export function currency(value: number, currencyParams?: Partial<CurrencyOptions>): string {
  if (currencyParams) {
    const store = container.get<Store<RootStoreState>>(DEPENDENCIES.Store);
    const defaultOptions = store.getters[GETTERS_KEYS.config.currency];
    const customOptions = { ...defaultOptions, ...currencyParams };
    // Because receiving template custom parameters shouldn't be the common case,
    // we can create a custom CurrencyFormatter instance with the config merged parameters
    return new CurrencyFormatter(customOptions).format(value);
  } else {
    return DefaultFormatter.format(value);
  }
}
